import type { PayloadAction } from '@reduxjs/toolkit';
import isEmpty from 'lodash/isEmpty';
import type { ValueOf } from 'src/helper/shared-types';
import {
  type InitialStateType,
  type VendorDataType,
  vendorInitialState,
} from 'src/redux/vendors/types';
import type { OnboardingSteps } from '../vendor-portal/onboarding/types';

const reducers = {
  clearVendorListData: (state: InitialStateType) => {
    state.data = vendorInitialState?.data;
  },

  updateVendorDetails: (
    state: InitialStateType,
    action: PayloadAction<{
      vendorId: string;
      data: VendorDataType | ValueOf<VendorDataType>;
      key: string;
    }>,
  ) => {
    const currentData = { ...(state?.source || {}) };
    if (!isEmpty(action?.payload?.key)) {
      const updatedVendor = {
        ...(state?.source?.[action?.payload?.vendorId] || {}),
        [action?.payload?.key]: action?.payload?.data,
      };
      state.source = { ...currentData, [action?.payload?.vendorId]: updatedVendor };
    } else {
      state.source = {
        ...currentData,
        [action?.payload?.vendorId]: action?.payload?.data as VendorDataType,
      };
    }
  },

  updateVendorOnboardStatus: (
    state: InitialStateType,
    action: PayloadAction<{
      vendorId: string;
      data: { name: string; slug: OnboardingSteps };
      onboardingId: string;
    }>,
  ) => {
    const currentData = { ...(state?.source || {}) };
    const updatedVendor = {
      ...(state?.source?.[action?.payload?.vendorId] || {}),
      onboarding: {
        vendor_onboarding_id: action?.payload?.onboardingId || '',
        status: {
          label: action?.payload?.data?.name || '',
          slug: action?.payload?.data?.slug || '',
        },
      },
    };
    state.source = { ...currentData, [action?.payload?.vendorId]: updatedVendor };
  },
};
export default reducers;
